// Breakpoint-specific heights
export const HEADER_HEIGHT = {
  TOP_BAR: {
    xs: 36,
    sm: 36,
    md: 45,
    lg: 45,
    xl: 45,
    // xs: 0,
    // sm: 0,
    // md: 0,
    // lg: 0,
    // xl: 0,
  },
  MAIN_HEADER: {
    xs: 76, // 112
    sm: 76, // 150
    md: 76, // 180
    lg: 76, // 109
    xl: 76, // 109
  },
  NAV_CATEGORIES: {
    xs: 37,
    sm: 37,
    md: 37,
    lg: 37,
    xl: 37,
  },
  BOTTOM_NAV: {
    xs: 0, // Only visible on mobile 56
    sm: 0, //56
    md: 0, // Hidden from medium screens
    lg: 0,
    xl: 0,
  },
} as const

// Calculate total heights for each breakpoint
export const TOTAL_HEADER_HEIGHT = {
  xs: HEADER_HEIGHT.MAIN_HEADER.xs + HEADER_HEIGHT.TOP_BAR.xs,
  sm: HEADER_HEIGHT.MAIN_HEADER.sm + HEADER_HEIGHT.TOP_BAR.sm,
  md: HEADER_HEIGHT.TOP_BAR.md + HEADER_HEIGHT.MAIN_HEADER.md + HEADER_HEIGHT.NAV_CATEGORIES.md,
  lg: HEADER_HEIGHT.TOP_BAR.lg + HEADER_HEIGHT.MAIN_HEADER.lg + HEADER_HEIGHT.NAV_CATEGORIES.lg,
  xl: HEADER_HEIGHT.TOP_BAR.xl + HEADER_HEIGHT.MAIN_HEADER.xl + HEADER_HEIGHT.NAV_CATEGORIES.xl,
} as const

// Convert to pixel strings for direct CSS usage
export const HEADER_HEIGHT_PX = {
  TOP_BAR: {
    xs: `${HEADER_HEIGHT.TOP_BAR.xs}px`,
    sm: `${HEADER_HEIGHT.TOP_BAR.sm}px`,
    md: `${HEADER_HEIGHT.TOP_BAR.md}px`,
    lg: `${HEADER_HEIGHT.TOP_BAR.lg}px`,
    xl: `${HEADER_HEIGHT.TOP_BAR.xl}px`,
  },
  MAIN_HEADER: {
    xs: `${HEADER_HEIGHT.MAIN_HEADER.xs}px`,
    sm: `${HEADER_HEIGHT.MAIN_HEADER.sm}px`,
    md: `${HEADER_HEIGHT.MAIN_HEADER.md}px`,
    lg: `${HEADER_HEIGHT.MAIN_HEADER.lg}px`,
    xl: `${HEADER_HEIGHT.MAIN_HEADER.xl}px`,
  },
  NAV_CATEGORIES: {
    xs: `${HEADER_HEIGHT.NAV_CATEGORIES.xs}px`,
    sm: `${HEADER_HEIGHT.NAV_CATEGORIES.sm}px`,
    md: `${HEADER_HEIGHT.NAV_CATEGORIES.md}px`,
    lg: `${HEADER_HEIGHT.NAV_CATEGORIES.lg}px`,
    xl: `${HEADER_HEIGHT.NAV_CATEGORIES.xl}px`,
  },
  BOTTOM_NAV: {
    // xs: `var(--bottom-nav-height-xs, ${HEADER_HEIGHT.BOTTOM_NAV.xs}px)`,
    xs: `${HEADER_HEIGHT.BOTTOM_NAV.xs}px`,
    // sm: `var(--bottom-nav-height-sm, ${HEADER_HEIGHT.BOTTOM_NAV.sm}px)`,
    sm: `${HEADER_HEIGHT.BOTTOM_NAV.sm}px`,
    md: `${HEADER_HEIGHT.BOTTOM_NAV.md}px`,
    lg: `${HEADER_HEIGHT.BOTTOM_NAV.lg}px`,
    xl: `${HEADER_HEIGHT.BOTTOM_NAV.xl}px`,
  },
  TOTAL: {
    xs: `${TOTAL_HEADER_HEIGHT.xs}px`,
    sm: `${TOTAL_HEADER_HEIGHT.sm}px`,
    md: `${TOTAL_HEADER_HEIGHT.md}px`,
    lg: `${TOTAL_HEADER_HEIGHT.lg}px`,
    xl: `${TOTAL_HEADER_HEIGHT.xl}px`,
  },
  MAIN: {
    xs: `calc(100vh - ${TOTAL_HEADER_HEIGHT.xs}px)`,
    sm: `calc(100vh - ${TOTAL_HEADER_HEIGHT.sm}px)`,
    md: `calc(100vh - ${TOTAL_HEADER_HEIGHT.md}px)`,
    lg: `calc(100vh - ${TOTAL_HEADER_HEIGHT.lg}px)`,
    xl: `calc(100vh - ${TOTAL_HEADER_HEIGHT.xl}px)`,
  },
} as const

export const PADDING_CONTAINER = {
  xs: 2,
  sm: 3,
  md: 4,
  lg: 5,
  xl: 7,
  xxl: 8.5,
} as const
// MUI breakpoint reference (in pixels)
export const BREAKPOINTS = {
  xs: 0,
  xsm: 400,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
} as const
export const COMMON_SPACING_SECTION = {
  xs: 4,
  sm: 6,
  md: 8,
  lg: 10,
  xl: 12,
  xxl: 15,
}
export const HOME_SPACING_SECTION = {
  xs: 6,
  lg: 10,
}
